import { Message } from 'element-ui';
const MessageWrapper = Message
export default MessageWrapper;
